import { RestrictionCriteria } from '@iota/iota-management-portal-v4-client';

export const RestrictionCriterias = [RestrictionCriteria.AGE, RestrictionCriteria.GENDER];

export const RestrictionCriteriaDescriptions = new Map([
    [RestrictionCriteria.AGE, 'Alter'],
    [RestrictionCriteria.GENDER, 'Geschlecht']
]);
